const _excluded = ["filteredBusinessUnits", "selectedBUDashboard", "labels", "selectedYears", "companyId", "selectedSubsidiaryCompanyIds", "dashboard_raw_projects"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useEffect } from 'react';
import PieChart from '@rd-web-markets/shared/dist/dashboards/components/PieChart';
import projectReviewCompletionsService from './project_review_completions.service';
const statusMapping = {
  unstarted: 'not_started',
  begun_tech_interview_scheduled: 'in_progress',
  begun_tech_interview_completed: 'in_progress',
  begun_in_manager_qa: 'in_progress',
  begun_manager_qa_completed: 'in_progress',
  finished: 'completed',
  shortlisted_sampled: 'in_progress',
  scoping_scheduled: 'in_progress',
  scoping_completed: 'in_progress'
};
const BusinessProjectStatePieChart = _ref => {
  let {
      filteredBusinessUnits,
      selectedBUDashboard,
      labels = ['Completed', 'Not Started', 'In Progress'],
      selectedYears,
      companyId,
      selectedSubsidiaryCompanyIds,
      dashboard_raw_projects
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const buIds = selectedBUDashboard.map(bu => {
        var _bu$business_unit_id;
        return (_bu$business_unit_id = bu.business_unit_id) !== null && _bu$business_unit_id !== void 0 ? _bu$business_unit_id : 0;
      }).join(',');
      const scIds = selectedSubsidiaryCompanyIds.join(',');
      const data = await projectReviewCompletionsService.all(companyId, buIds, scIds, selectedYears);
      setChartData(data);
    };
    fetchData();
  }, [companyId, selectedBUDashboard, selectedSubsidiaryCompanyIds, selectedYears]);
  const series = [chartData['completed'] || 0, chartData['not_started'] || 0, chartData['in_progress'] || 0];
  return /*#__PURE__*/React.createElement("div", {
    className: "p-2 dashboard-card"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center dashboard-regular-card-title"
  }, "Project Review Completion"), /*#__PURE__*/React.createElement(PieChart, {
    className: "pos-rel-top-10",
    labels: labels,
    series: series,
    label: 'Total Projects'
  }));
};
export default BusinessProjectStatePieChart;